export default {
    keyField: 'Cliente',
    account1: 'C1',
    account2: 'C2\r',
}